import BaseInput, { IBaseInputProps } from './BaseInput';
import TextArea, { ITextareaProps } from './TextArea';

export type TInputOrTextArea = ITextareaProps | IBaseInputProps;

const isPropsForTextarea = (props: TInputOrTextArea): props is ITextareaProps => {
  return !!props.textarea;
};

const InputComponent = (props: TInputOrTextArea) => {
  const isTextarea = isPropsForTextarea(props);
  if (isTextarea) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (
      <TextArea
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        /** we shouldn't be passing textarea down to the base component */
        textarea={undefined}
      />
    );
  }
  return (
    <BaseInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      /** we shouldn't be passing textarea down to the base component */
      textarea={undefined}
    />
  );
};

export default InputComponent;
export const BaseInputComponent = InputComponent;
